import { useCallback, useLayoutEffect, useRef } from 'react'

function useEvent<T extends (...args: unknown[]) => unknown>(handler?: T): T | null {
  const handlerRef = useRef<T | null>(null)

  useLayoutEffect(() => {
    handlerRef.current = handler ?? null
  })

  return useCallback((...args: unknown[]) => {
    const callback = handlerRef.current

    return callback && callback(...args)
  }, []) as T | null
}

export default useEvent
